const getCookie = (name) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}

export const getHeadersWithToken = () => {
  const token = decodeURIComponent(getCookie('XSRF-TOKEN'))
  return {
    'Content-Type': 'application/json; charset=utf-8',
    'X-XSRF-TOKEN': token,
    Accept: 'application/json, text/plain, */*',
    'X-Requested-With': 'XMLHttpRequest'
  }
}

export const handleResponse = async (type, resp) => {
  const contentType = resp.headers.get('content-type')

  if (!resp.ok) {
    if (contentType && contentType.includes('application/json')) {
      const json = await resp.json()
      throw new Error(json.message ?? `Failed to ${type}`)
    }
    throw new Error(`Failed to ${type}`)
  }

  if (contentType && contentType.includes('application/json')) {
    return [resp.status, await resp.json()]
  }

  return [resp.status, resp.text()]
}
